module.exports = __webpack_public_path__ + "img/signin.860c5e12.jpg";